import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { D } from '@shared/constants/date';

@Pipe({
    name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value) {
            return '';
        }
        return super.transform(value, args && args.format ? args.format : D.DATE_DE);
    }
}
